module.exports = __webpack_public_path__ + "static/bg-mobile-hq-ec56f8a579176cc7d90b1a606f4c3436.png";